// extracted by mini-css-extract-plugin
export default {"modal":"CustomDateFilter_modal__P+Iwg","label":"CustomDateFilter_label__My0Q2"};